import type { World } from '../../engine/ecs';
import { Tile, TILE_SIZE, tileAt, type TileMap } from '../../world/tilemap';
import { Facing, Position } from '../components';

/**
 * Interazioni col mondo: guarda il tile davanti al giocatore quando preme
 * il tasto azione. Per ora: Stazione di Risonanza (cura) e anomalie (lore).
 */

export type Interaction =
  | { kind: 'healStation' }
  | { kind: 'anomalyInfo' }
  | { kind: 'none' };

export function interactionInFront(world: World, playerEntity: number, map: TileMap): Interaction {
  const pos = world.require(playerEntity, Position);
  const facing = world.require(playerEntity, Facing);

  const dx = facing.dir === 'sinistra' ? -1 : facing.dir === 'destra' ? 1 : 0;
  const dy = facing.dir === 'su' ? -1 : facing.dir === 'giu' ? 1 : 0;

  const tx = Math.floor(pos.x / TILE_SIZE) + dx;
  const ty = Math.floor((pos.y - 4) / TILE_SIZE) + dy;
  const tile = tileAt(map, tx, ty);

  if (tile === Tile.HealStation) return { kind: 'healStation' };
  if (tile === Tile.Anomaly) return { kind: 'anomalyInfo' };
  return { kind: 'none' };
}
